import { Preset } from '~src/types/knife'

import Standart from './_standart.preset'
import Advanced from './_advanced.preset'

export default [Standart, Advanced] as Preset[]
